import React from "react";

export interface RemoveFeatureConfirmModalProps {
  isPending: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const RemoveFeatureConfirmModal: React.FC<RemoveFeatureConfirmModalProps> = ({
  isPending,
  onConfirm,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
      <div className="bg-white rounded-lg max-w-md w-full mx-4">
        <div className="px-6 py-4 border-b border-neutral-200">
          <h3 className="text-lg font-semibold text-neutral-900">
            Usuń feature
          </h3>
        </div>
        <div className="p-6">
          <p className="text-neutral-700 text-sm">
            Czy na pewno chcesz usunąć ten feature?
          </p>
        </div>
        <div className="px-6 py-4 border-t border-neutral-200 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-neutral-600 hover:text-neutral-800 font-medium"
          >
            Anuluj
          </button>
          <button
            onClick={onConfirm}
            disabled={isPending}
            className="px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors"
          >
            {isPending ? "Usuwanie..." : "Usuń"}
          </button>
        </div>
      </div>
    </div>
  );
};
